import ApprovedUsers from "./tabs/approvedUsers/ApprovedUsers";
import PendingUsers from "./tabs/pendingUsers/PendingUsers";

export const tabsTrigger = [
  { value: "approved", label: "Approved" }, 
  { value: "pending", label: "Pending" }, 
];

export const tabsContent = [
  { 
    value: "approved",
    element: (
      <>
        <ApprovedUsers />
      </>
    ),
  },
 {
  value: "pending",
  element: (
    <>
      <PendingUsers />
    </>
  ),
 }
];
